import catalog from '@/constants/partnerFeatures.json'

const FEATURE_KEY = /^[a-z][a-z0-9_]{0,40}$/

export const PARTNER_FEATURES = (Array.isArray(catalog) ? catalog : []).filter(
  feature => feature && FEATURE_KEY.test(feature.key)
)

export function hasPartnerFeature(user, key) {
  return user?.partner?.features?.[key] === true
}
